import normalLoginDialogs from './normalLoginDialogs.json';
import wellBelowLoginDialogs from './wellBelowLoginDialogs.json';
import normalPathwayDialogs from './normalPathwayDialogs.json';
import wellBelowPathwayDialogs from './wellBelowPathwayDialogs.json';
import notificationStatuses from './notificationStatuses.json';
import { WORKSHOP_BENCHMARK_IDS } from '../constants';

/**
 * Get the login dialog for a specific message id, which is determined by the workshop step config.
 * @param {string} loginTextId - The message id, ie 'skill_game_1'
 * @param {string} benchmarkId - The benchmark ID, either 'NORMAL' or 'WELL_BELOW'
 * @param {boolean} isStepInProgress - Whether the step is in progress, it will append '_in_progress' to the message id
 * @returns {Array} - A list of login dialogs which will get rendered as bullet points.
 */
export const getLoginDialogs = (loginTextId, benchmarkId, isStepInProgress = false) => {
  const dialogs = benchmarkId === WORKSHOP_BENCHMARK_IDS.NORMAL ? normalLoginDialogs : wellBelowLoginDialogs;

  const posfix = isStepInProgress ? '_in_progress' : '';
  const targetId = loginTextId + posfix;

  let targetDialogs = dialogs.filter((dialog) => dialog.loginTextId === targetId);
  if (targetDialogs.length === 0) {
    targetDialogs = dialogs.filter((dialog) => dialog.loginTextId === loginTextId);
  }
  return targetDialogs;
};

const getProgressDialogs = (benchmarkId) => {
  const dialogs = benchmarkId === WORKSHOP_BENCHMARK_IDS.NORMAL ? normalPathwayDialogs : wellBelowPathwayDialogs;
  return dialogs;
};

/**
 * Get the progress dialog for a specific activity id and status
 * @param {string} benchmarkId - The benchmark ID
 * @param {string} targetActivityId - The target activity ID
 * @param {string} status - The status of the activity, either 'not_started', 'in_progress' or 'complete'
 * @param {boolean} isOnboarding - Whether the activity is part of the onboarding process
 * @returns {Object} - The progress dialog object
 */
export const getProgressDialogByActivityIndexAndStatus = (
  benchmarkId,
  targetActivityId,
  status,
  isOnboarding = false,
) => {
  const dialogs = getProgressDialogs(benchmarkId);
  // If the activity is part of the onboarding process, we need to append '_onboarding' to the activity ID
  // to get the correct dialog.
  const id = isOnboarding ? `${targetActivityId}_onboarding` : targetActivityId;

  let targetDialogs = dialogs.find((dialog) => dialog.status === status && dialog.activityId === id);
  // We default to the original activity ID in case it does not exist.
  if (!targetDialogs) {
    targetDialogs = dialogs.find((dialog) => dialog.status === status && dialog.activityId === targetActivityId);
  }
  return targetDialogs;
};

export const getNotificationMessage = (activityType, activityStatus, targetActivity = '-') => {
  const notification = notificationStatuses.find(
    ({ type, status, target }) =>
      type === activityType &&
      target === targetActivity &&
      status === activityStatus,
  );
  return notification || {};
};
